import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigService<T> {
  private _config!: T;

  get config() {
    return this._config;
  }

  set config(config: T) {
    this._config = config;
  }
}
